import { baseURL } from "../app/api";
import gsApi from "../auth/auth";
import { getRouting } from "../helpers/Converters";
import {
  getIDRelationship,
  getOpts,
  getResponse,
  getSerializedData,
} from "../helpers/JSONapi";

export const REGISTRATION_ORDER = "registration-orders";
export const REGISTRATION_ORDER_ITEM = "registration-order-items";
export const DONATION_ORDER_ITEM = "donation-order-items";
export const REGISTRATION_CUSTOMER = "registration-customers";
export const IN_PPROGRESS_SPONSORS = "in-progress-sponsors";
export const IN_PPROGRESS_PLAYERS = "in-progress-players";
export const IN_PPROGRESS_TEAMS = "in-progress-teams";
export const IN_PPROGRESS_ROUND_HOLE_ASSIGNMENTS =
  "in-progress-round-hole-assignments";
export const CUSTOM_FIELD_RESPONSES = "custom-field-responses";
export const ADDRESSES = "addresses";

//order
export const getRegistrationOrder = async (id, thunkAPI) => {
  const response = await getResponse(
    gsApi.get,
    getRouting(baseURL, [REGISTRATION_ORDER, id]),
    null,
    thunkAPI
  );
  return response;
};

export const createOrder = async (registrationOrder, thunkAPI) => {
  let serializedData = getSerializedData(
    registrationOrder,
    "registration-orders",
    getOpts(registrationOrder, [
      ...getIDRelationship("tournament"),
      ...getIDRelationship("registrationCustomer"),
      ...getIDRelationship("paymentOption"),
    ])
  );
  const response = await getResponse(
    gsApi.post,
    getRouting(baseURL, [REGISTRATION_ORDER]),
    serializedData,
    thunkAPI
  );
  return response;
};

export const updateRemoteRegistrationOrder = async (
  registrationOrder,
  thunkAPI
) => {
  registrationOrder.customFieldResponses?.forEach?.((cfr) =>
    updateCustomFieldResponse(cfr, thunkAPI)
  );

  let serializedData = getSerializedData(
    registrationOrder,
    "registration-orders",
    getOpts(registrationOrder, [
      ...getIDRelationship("tournament"),
      ...getIDRelationship("discountCode"),
      ...getIDRelationship("registrationCustomer"),
      ...getIDRelationship("paymentOption"),
    ])
  );
  const { id } = registrationOrder;
  const response = await getResponse(
    gsApi.put,
    getRouting(baseURL, [REGISTRATION_ORDER, id]),
    serializedData,
    thunkAPI
  );

  return response;
};

export const deleteRemoteRegistrationOrder = async (
  registrationOrder,
  thunkAPI
) => {
  const { id } = registrationOrder;
  if(id === "new-order" || !id){
    return
  }
  return await getResponse(
    gsApi.delete,
    getRouting(baseURL, [REGISTRATION_ORDER, id]),
    { data: {} },
    thunkAPI
  );
};

//order items
export const getRegistrationOrderItem = async (id, thunkAPI) => {
  const response = await getResponse(
    gsApi.get,
    getRouting(baseURL, [REGISTRATION_ORDER_ITEM, id]),
    null,
    thunkAPI
  );
  return response;
};

export const createOrderItem = async (registrationOrderItem, thunkAPI) => {
  let serializedData = getSerializedData(
    registrationOrderItem,
    "registration-order-items",
    getOpts(registrationOrderItem, [
      ...getIDRelationship("tournamentPackage"),
      ...getIDRelationship("registrationOrder"),
      ...getIDRelationship("accessGroupMember"),
    ])
  );

  const response = await getResponse(
    gsApi.post,
    getRouting(baseURL, [REGISTRATION_ORDER_ITEM]),
    serializedData,
    thunkAPI
  );

  return response;
};

export const updateOrderItem = async (registrationOrderItem, thunkAPI) => {
  let serializedData = getSerializedData(
    registrationOrderItem,
    "registration-order-items",
    getOpts(registrationOrderItem, [])
  );

  const { id } = registrationOrderItem;
  const response = await getResponse(
    gsApi.put,
    getRouting(baseURL, [REGISTRATION_ORDER_ITEM, id]),
    serializedData,
    thunkAPI
  );

  if(response?.payload?.errors?.length > 0){
    const rejection = {
      rejected: true,
      error: { message: response?.payload?.errors?.[0]?.detail} 
      
    }
    return thunkAPI?.rejectWithValue?.(rejection);
  }
  
  return response;
};

export const deleteOrderItem = async (registrationOrderItem, thunkAPI) => {
  const { id } = registrationOrderItem;
  await getResponse(
    gsApi.delete,
    getRouting(baseURL, [REGISTRATION_ORDER_ITEM, id]),
    { data: {} },
    thunkAPI
  );
  return getRegistrationOrder(
    registrationOrderItem?.registrationOrder?.id,
    thunkAPI
  );
};

//donations
export const createDonationOrderItem = async (donationOrderItem, thunkAPI) => {
  let serializedData = getSerializedData(
    donationOrderItem,
    "donation-order-items",
    getOpts(donationOrderItem, [...getIDRelationship("registrationOrder")])
  );

  const response = await getResponse(
    gsApi.post,
    getRouting(baseURL, [DONATION_ORDER_ITEM]),
    serializedData,
    thunkAPI
  );

  return response;
};

export const updateDonationOrderItem = async (donationOrderItem, thunkAPI) => {
  let serializedData = getSerializedData(
    donationOrderItem,
    "donation-order-items",
    getOpts(donationOrderItem, [])
  );

  const { id } = donationOrderItem;
  const response = await getResponse(
    gsApi.put,
    getRouting(baseURL, [DONATION_ORDER_ITEM, id]),
    serializedData,
    thunkAPI
  );
  return response;
};

export const deleteDonationOrderItem = async (donationOrderItem, thunkAPI) => {
  const { id } = donationOrderItem;
  const response = await getResponse(
    gsApi.delete,
    getRouting(baseURL, [DONATION_ORDER_ITEM, id]),
    { data: {} },
    thunkAPI
  );
  return response;
};

//in progress forms

export const updateInProgressSponsor = async (InProgressSponsor, thunkAPI) => {
  let serializedData = getSerializedData(
    InProgressSponsor,
    "in-progress-sponsors",
    getOpts(InProgressSponsor, [])
  );

  const { id } = InProgressSponsor;
  const response = await getResponse(
    gsApi.put,
    getRouting(baseURL, [IN_PPROGRESS_SPONSORS, id]),
    serializedData,
    thunkAPI
  );

  InProgressSponsor.customFieldResponses.forEach((cfr) =>
    updateCustomFieldResponse(cfr, thunkAPI)
  );

  return response;
};

export const updateInProgressPlayer = async (InProgressPlayer, thunkAPI) => {
  let serializedData = getSerializedData(
    InProgressPlayer,
    "in-progress-payers",
    getOpts(InProgressPlayer, [])
  );

  const { id } = InProgressPlayer;
  const response = await getResponse(
    gsApi.put,
    getRouting(baseURL, [IN_PPROGRESS_PLAYERS, id]),
    serializedData,
    thunkAPI
  );
  InProgressPlayer.customFieldResponses.forEach((cfr) =>
    updateCustomFieldResponse(cfr, thunkAPI)
  );
  return response;
};

export const updateInProgressTeamHoleAssignments = async (
  inProgressTeam,
  thunkAPI
) => {
  const responses = [];
  for (const holeAssignment of inProgressTeam?.inProgressTournamentTeamsRoundHoleAssignments) {
    const holeAssignmentResponse = await updateInProgressRoundHoleAssignment(
      {
        ...holeAssignment,
      },
      thunkAPI
    );
    responses.push(holeAssignmentResponse);
  }
  return responses;
};

export const updateInProgressTeam = async (inProgressTeam, thunkAPI) => {
  if (inProgressTeam?.inProgressTournamentTeamsRoundHoleAssignments) {
    const holeAssignmentResponse = await updateInProgressTeamHoleAssignments(
      inProgressTeam,
      thunkAPI
    );
    if (holeAssignmentResponse.length > 0) {
      const rejected = holeAssignmentResponse?.find?.(
        (har) => har?.payload?.rejected
      );
      if (rejected) {
        return rejected;
      }
    }
  }

  let serializedData = getSerializedData(
    inProgressTeam,
    "in-progress-teams",
    getOpts(inProgressTeam, [])
  );

  let response = {};

  inProgressTeam.inProgressPlayers?.forEach?.((p) =>
    updateInProgressPlayer(p, thunkAPI)
  );
  inProgressTeam.customFieldResponses.forEach((cfr) =>
    updateCustomFieldResponse(cfr, thunkAPI)
  );

  const {
    id,
    contactName,
    email,
    handicap,
    name,
    phone,
    teePreference,
  } = inProgressTeam;
  if (contactName || email || handicap || name || phone || teePreference) {
    response = await getResponse(
      gsApi.put,
      getRouting(baseURL, [IN_PPROGRESS_TEAMS, id]),
      serializedData,
      thunkAPI
    );
  }

  return response;
};

export const createInProgressRoundHoleAssignment = async (
  inProgressRoundHoleAssignment,
  thunkAPI
) => {
  let serializedData = getSerializedData(
    inProgressRoundHoleAssignment,
    "in-progress-round-hole-assignments",
    getOpts(inProgressRoundHoleAssignment, [
      ...getIDRelationship("inProgressTournamentTeam"),
      ...getIDRelationship("roundHoleAssignment"),
    ])
  );

  const response = await getResponse(
    gsApi.post,
    getRouting(baseURL, [IN_PPROGRESS_ROUND_HOLE_ASSIGNMENTS]),
    serializedData,
    thunkAPI
  );

  return response;
};

export const updateInProgressRoundHoleAssignment = async (
  inProgressRoundHoleAssignment,
  thunkAPI
) => {
  let serializedData = getSerializedData(
    inProgressRoundHoleAssignment,
    "in-progress-round-hole-assignments",
    getOpts(inProgressRoundHoleAssignment, [
      ...getIDRelationship("roundHoleAssignment"),
    ])
  );

  const { id } = inProgressRoundHoleAssignment;
  const response = await getResponse(
    gsApi.put,
    getRouting(baseURL, [IN_PPROGRESS_ROUND_HOLE_ASSIGNMENTS, id]),
    serializedData,
    thunkAPI
  );

  return response;
};

//custom fields

export const updateCustomFieldResponse = async (
  customFieldResponse,
  thunkAPI
) => {
  let serializedData = getSerializedData(
    customFieldResponse,
    "custom-field-responses",
    getOpts(customFieldResponse, [])
  );

  const { id } = customFieldResponse;
  const response = await getResponse(
    gsApi.put,
    getRouting(baseURL, [CUSTOM_FIELD_RESPONSES, id]),
    serializedData,
    thunkAPI
  );

  return response;
};

//customer
export const createRegistrationCustomer = async (customer, thunkAPI) => {
  let serializedData = getSerializedData(
    customer,
    "registration-customers",
    getOpts(customer, [
      ...getIDRelationship("tournament")
    ])
  );

  const response = await getResponse(
    gsApi.post,
    getRouting(baseURL, [REGISTRATION_CUSTOMER]),
    serializedData,
    thunkAPI
  );

  if (customer?.registrationOrder) {
    updateRemoteRegistrationOrder(
      { ...customer?.registrationOrder, registrationCustomer: response },
      thunkAPI
    );
  }

  return response;
};

export const updateRegistrationCustomer = async (customer, thunkAPI) => {
  let serializedData = getSerializedData(
    customer,
    "registration-customers",
    getOpts(customer, [
      ...getIDRelationship("tournament")
    ])
  );

  const { id } = customer;
  const response = await getResponse(
    gsApi.put,
    getRouting(baseURL, [REGISTRATION_CUSTOMER, id]),
    serializedData,
    thunkAPI
  );

  if (customer?.registrationOrder) {
    updateRemoteRegistrationOrder(
      { ...customer?.registrationOrder, registrationCustomer: customer },
      thunkAPI
    );
  }

  return response;
};

//billing address
export const createRemoteBillingAddress = async (billingAdddress, thunkAPI) => {
  let serializedData = getSerializedData(
    billingAdddress,
    "addresses",
    getOpts(billingAdddress, [])
  );

  serializedData.data.relationships = {
    addressable: {
      data: {
        type: "registrationOrder",
        id: billingAdddress?.registrationOrder?.id,
      },
    },
  };

  const response = await getResponse(
    gsApi.post,
    getRouting(baseURL, [ADDRESSES]),
    serializedData,
    thunkAPI
  );

  return response;
};

export const updateRemoteBillingAddress = async (billingAdddress, thunkAPI) => {
  let serializedData = getSerializedData(
    billingAdddress,
    "addresses",
    getOpts(billingAdddress, [])
  );
  const { id } = billingAdddress;
  const response = await getResponse(
    gsApi.put,
    getRouting(baseURL, [ADDRESSES, id]),
    serializedData,
    thunkAPI
  );

  return response;
};

export const payOrder = async (captchaOrder, thunkAPI) => {
  const { registrationOrderId, saveCard } = captchaOrder;
  const captcha_data =
    { ...captchaOrder?.captcha_data, captcha_action: "pay" } ?? {};

  const savePayment = saveCard;
  if (registrationOrderId) {
    const response = await getResponse(
      gsApi.post,
      getRouting(baseURL, [
        REGISTRATION_ORDER,
        registrationOrderId,
        "pay-order",
      ]),
      { captcha_data, savePayment },
      thunkAPI
    );

    return response;
  }
};

//order actions
export const addROI = async (registrationOrderItem, thunkAPI) => {
  const { registrationOrder, tournamentPackage } = registrationOrderItem;

  const accessGroupMember = registrationOrderItem?.accessGroupMember ?? {};

  const orderID = registrationOrder?.id;

  let response = registrationOrder;

  if (orderID === "new-order") {
    response = await createOrder(registrationOrder, thunkAPI);
  }

  const itemIndex = response.registrationOrderItems?.findIndex?.((roi) => {
    return roi.tournamentPackage?.id === tournamentPackage?.id;
  });

  if (itemIndex >= 0) {
    const items = [...response?.registrationOrderItems] ?? [];
    const item = items?.[itemIndex] ?? {};
    const itemResponse = await updateOrderItem({
      ...item,
      registrationOrder: registrationOrder,
      quantity: (item?.quantity ?? 0) + 1,
    }, thunkAPI);
    if (itemResponse && !itemResponse?.payload?.rejected) {
      items[itemIndex] = {
        ...itemResponse,
        registrationOrder: null,
        tournamentPackage,
      };
      response = { ...response, ...itemResponse?.registrationOrder };

      response.registrationOrderItems = items;
    } else {
      if(itemResponse?.payload?.error?.message){
        return itemResponse
      }
      return thunkAPI?.rejectWithValue?.({
        error: { message: "Could not update the order item" },
        rejected: true,
      });
    }
  } else {
    const currentItems = response?.registrationOrderItems ?? [];
    const itemResponse = await createOrderItem({
      tournamentPackage,
      registrationOrder: response,
      accessGroupMember,
      quantity: 1,
    });
    if (itemResponse) {
      response = { ...response, ...itemResponse?.registrationOrder };
      response.registrationOrderItems = [
        ...currentItems,
        { ...itemResponse, registrationOrder: null, tournamentPackage },
      ];
    }
    else{
      return thunkAPI?.rejectWithValue?.({
        error: { message: "Could not update the order item" },
        rejected: true,
      });
    }
  }

  return response;
};

export const removeROI = async (registrationOrderItem, thunkAPI) => {
  const itemResponse = await updateOrderItem(
    {
      ...registrationOrderItem,
      quantity: (registrationOrderItem?.quantity ?? 0) - 1,
    },
    thunkAPI
  );
  return itemResponse;
};

export const saveCustomer = async (customer, thunkAPI) => {
  if (customer?.id && customer?.id !== "blank_customer") {
    return updateRegistrationCustomer(customer, thunkAPI);
  } else {
    return createRegistrationCustomer(customer, thunkAPI);
  }
};

export const addDonation = async (donationOrderItem, thunkAPI) => {
  const donation = { ...donationOrderItem };
  const { registrationOrder } = donation;

  const orderID = registrationOrder?.id;

  let response = { ...registrationOrder };

  if (donationOrderItem?.amount === "0") {
    return response;
  }
  if (orderID === "new-order") {
    response = await createOrder(registrationOrder, thunkAPI);
    donation.registrationOrder = response;
  }

  const itemResponse = await createDonationOrderItem(donation, thunkAPI);
  response = { ...response, ...itemResponse?.registrationOrder };

  return response;
};
